import { createContext, useContext, ReactNode, ReactElement } from "react";

// Exposes just the bearer token, sourced from the same AuthContext value
// that already threads `axiosInstance` into ApiProvider (see
// ApiProviderWrapper in broker-portal-fe's Providers.js) — for a caller that
// needs a raw fetch() with auth (e.g. reading a streamed response body,
// where axios's onDownloadProgress is throttled) rather than going through
// the shared axios instance.
const AccessTokenContext = createContext<string | null>(null);

interface AccessTokenProviderProps {
  children: ReactNode;
  token: string | null;
}

export function AccessTokenProvider({
  children,
  token,
}: AccessTokenProviderProps): ReactElement {
  return (
    <AccessTokenContext.Provider value={token}>
      {children}
    </AccessTokenContext.Provider>
  );
}

export function useAccessToken(): string | null {
  return useContext(AccessTokenContext);
}
